import {take} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import * as savActionTypes from '../savActionTypes';
import modalIds from '../../modalIds';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';

/**
 * Update SAV damage description flow
 */
const updateSAVDamageDescriptionFlow = function* updateSAVDamageDescriptionFlow() {
    while (true) {
        const {payload} = yield take(savActionTypes.INITIATE_SAV_DAMAGE_DESCRIPTION_UPDATE_FLOW);
        const {serviceCaseId, lineNo} = payload;

        yield* openModal(modalIds.DAMAGE_NOTE_MODAL, {serviceCaseId, lineNo});

        const chosenModalOption = yield take([
            savActionTypes.SUBMIT_SAV_DAMAGE_DESCRIPTION_FORM,
            savActionTypes.DECLINE_SAV_DAMAGE_DESCRIPTION_FORM,
        ]);

        if (chosenModalOption && chosenModalOption.type === savActionTypes.SUBMIT_SAV_DAMAGE_DESCRIPTION_FORM) {
            const {assignmentType, serviceAssignmentLineNo, serviceAssignmentData} = chosenModalOption.payload;

            yield* updateServiceAssignment({
                caller: savActionTypes.SUBMIT_SAV_DAMAGE_DESCRIPTION_FORM,
                assignmentType,
                serviceAssignmentLineNo,
                serviceAssignmentData,
                serviceCaseId,
            });
        }

        yield* closeModal(modalIds.DAMAGE_NOTE_MODAL, {serviceCaseId, lineNo});
    }
};

export default updateSAVDamageDescriptionFlow;
